const URL_PREVIEW_KINDS = new Set([
  'html',
  'pdf',
  'ppt',
  'pptx',
  'docx',
  'image',
  'png',
  'jpg',
  'jpeg',
  'webp',
  'svg',
])

export function isRenderable(selection) {
  if (!selection || typeof selection !== 'object') return false
  const payload = selection.payload && typeof selection.payload === 'object' ? selection.payload : null
  const kind = normalizeArtifactKind(selection.artifactKind || selection.kind)
  if (kind === 'zip') return false
  if (payload?.url || payload?.html) return true
  if (Array.isArray(payload?.sections) && payload.sections.length) return true
  if (Array.isArray(payload?.rows) && payload.rows.length) return true
  if ((selection.previewUrl || selection.downloadUrl) && URL_PREVIEW_KINDS.has(kind)) return true
  if (selection.downloadUrl && kind !== 'zip') return true
  return false
}

function normalizeArtifactKind(kind) {
  const value = String(kind || '').trim().toLowerCase().replace(/^\./, '')
  if (value === 'jpeg') return 'jpg'
  if (['png', 'jpg', 'webp', 'svg'].includes(value)) return value
  return value || 'file'
}
